import Enllac from 'components/3catinfo/Enllac';
import Imatge, { hasImatge } from 'components/3catinfo/Imatge';
import styles from './autor.module.scss';
import BotoSeguir from 'components/3catinfo/BotoSeguir';
import clsx from 'clsx';

const Autor = (props) => {
    const {
        item,
        mostrarSegueix,
        mostrarCarrec,
        mostrarApaisat,
        mostraEnllac = true,
        mostrarRecurs = true,
        estil,
        toggleSelection,
        obreEsquerra,
        className,
        enviaApi,
        originUsuaris
    } = props;
    const { id, nom, imatges, tipologia, carrec } = item;
    const route = { slug: nom, id, tipologia };
    const hasImatges = hasImatge(imatges, 'web_autor', null, null);

    const stylesAutor = clsx({
        [styles.contentAutor]: true,
        [styles[estil]]: !!estil,
        [className]: !!className
    });

    const stylesApaisat = clsx({
        [styles.innerAutor]: !mostrarApaisat,
        [styles.innerAutorApaisat]: mostrarApaisat
    });

    const stylesApaisatInfo = clsx({
        [styles.info]: !mostrarApaisat,
        [styles.innerAutorApaisat]: mostrarApaisat
    });

    const classNameNomAutor = mostrarApaisat ? styles.nomAutorApaisat : styles.nomAutor;

    const getImatge = () => {
        const imatgeAutor = hasImatges ? (
            <span>
                <Imatge
                    imatges={imatges}
                    tipus='web_autor'
                    alt={nom}
                    layout='fill'
                    objectFit='cover'
                    mostrarRecursTitol={false}
                    mostrarRecurs={mostrarRecurs}
                />
            </span>
        ) : (
            <span>
                <Imatge
                    src='/_resources/imatges/3catinfo/autor.png'
                    tipus='web_autor'
                    alt={nom}
                    layout='fill'
                    mostrarRecursTitol={false}
                    mostrarRecurs={mostrarRecurs}
                />
            </span>
        );

        const imageContent = mostraEnllac === true ? <Enllac route={route}>{imatgeAutor}</Enllac> : imatgeAutor;

        return (
            (hasImatges || mostrarRecurs) && (
                <div className={styles.contentImatge}>
                    <div key={`autor-imatge`} className={hasImatges ? styles.autorImatge : styles.autorImatgeDefault}>
                        {imageContent}
                    </div>
                </div>
            )
        );
    };

    const renderNomAutor = () => {
        if (mostraEnllac === true) {
            return (
                <p className={classNameNomAutor}>
                    <Enllac route={route}>{nom}</Enllac>
                </p>
            );
        }
        return <p className={classNameNomAutor}>{nom}</p>;
    };

    return (
        <div className={stylesAutor}>
            <div className={stylesApaisat}>
                <div className={stylesApaisatInfo}>
                    {getImatge()}
                    <div className={styles.infoDetalls}>
                        <div className={styles.detalls}>
                            {renderNomAutor()}
                            {mostrarCarrec && <p className={styles.carrec}>{carrec}</p>}
                        </div>
                        {mostrarSegueix && (
                            <div className={styles.botoSeguir}>
                                <BotoSeguir
                                    obreEsquerra={obreEsquerra}
                                    id={id}
                                    textHitAudiencies={nom}
                                    tipologia={'NOT_AUTOR'}
                                    toggleSelection={toggleSelection}
                                    origen={'AUTOR'}
                                    originUsuaris={originUsuaris}
                                    estil='petit'
                                    enviaApi={enviaApi}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Autor;
